import React, { useMemo, useRef } from 'react';
import withTranslation from 'hoc/withTranslation';
import NewJobMarkers from '../NewJobMarkers';

const NewMapMarker = ({ display, map, mapData, ui, user, oAuth }) => {
  const prevFeaturesRef = useRef(null);

  const memoizedGeoJSON = useMemo(() => {
    if (!mapData?.geo?.features) return mapData;

    const currentFeatures = mapData.geo.features;
    const prevFeatures = prevFeaturesRef.current;

    if (prevFeatures && currentFeatures.length === prevFeatures.length) {
      let hasChanged = false;

      for (let i = 0; i < currentFeatures.length; i++) {
        const curr = currentFeatures[i];
        const prev = prevFeatures[i];

        if (
          curr.properties?.id !== prev.properties?.id ||
          curr.geometry?.coordinates?.[0] !== prev.geometry?.coordinates?.[0] ||
          curr.geometry?.coordinates?.[1] !== prev.geometry?.coordinates?.[1] ||
          curr.properties?.isEditing !== prev.properties?.isEditing ||
          curr.properties?.isPickup !== prev.properties?.isPickup ||
          curr.properties?.highPriority !== prev.properties?.highPriority
        ) {
          hasChanged = true;
          break;
        }
      }

      if (!hasChanged) {
        return prevFeaturesRef.current.geoJSON;
      }
    }

    prevFeaturesRef.current = {
      geoJSON: mapData,
      features: currentFeatures,
    };

    return mapData;
  }, [mapData]);

  return (
    <>
      {display.showProblem && (
        <NewJobMarkers map={map} geoJSON={memoizedGeoJSON} ui={ui} user={user} oAuth={oAuth} />
      )}
    </>
  );
};

export default withTranslation(NewMapMarker);
